import request from '../../request';
import { constructUrlObject } from '../../../utils/shared/urlUtils';
import { URL, PARAM } from '../../../constants/shared/ApiConstants';

const { SPELLING_RESULTS, SPELLING_INTERPS, SPELLING_FORM } = URL.SPELLING;
const { STUDENT_IDS, LANGUAGE } = PARAM;

class SpellingClient {
    static getResults = (studentIds, language) => {
        const urlWithQueryParams = constructUrlObject(SPELLING_RESULTS, {
            [STUDENT_IDS]: studentIds.join(),
            [LANGUAGE]: language,
        });
        return request.get(urlWithQueryParams);
    };

    static getInterps = language => {
        const urlWithQueryParams = constructUrlObject(SPELLING_INTERPS, {
            [LANGUAGE]: language,
        });
        return request.get(urlWithQueryParams);
    };

    static getForm = formId => request.get(`${SPELLING_FORM}/${formId}`);
}

export default SpellingClient;
